import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/promotions/importer/promotionsImporterActions'

export default importerReducers(actions)
